/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by vite-plugin-generate-theme.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Themes included in the generation:
// base, dark, light, twilight

// --- Generated Variables ---

export const themeMap = {
  "base": {
    "--color-grey-50": "#f8fafc",
    "--color-grey-100": "#eef2f6",
    "--color-grey-200": "#e3e8ef",
    "--color-grey-300": "#cdd5df",
    "--color-grey-400": "#b7c0ce",
    "--color-grey-500": "#697586",
    "--color-grey-600": "#4b5565",
    "--color-grey-700": "#364152",
    "--color-grey-800": "#252f3f",
    "--color-grey-900": "#121926",
    "--color-grey-950": "#020617",
    "--breakpoint-xs": "480px",
    "--breakpoint-sm": "600px",
    "--breakpoint-md": "900px",
    "--breakpoint-lg": "1200px",
    "--breakpoint-xl": "1536px",
    "--breakpoint-2xl": "1920px",
    "--color-base-contrast": "var(--sg-color-base-contrast)",
    "--color-base-background": "var(--sg-color-base-background)",
    "--color-primary-light": "var(--sg-color-primary-light)",
    "--color-primary-main": "var(--sg-color-primary-main)",
    "--color-primary-dark": "var(--sg-color-primary-dark)",
    "--color-primary-contrast": "var(--sg-color-primary-contrast)",
    "--color-secondary-light": "var(--sg-color-secondary-light)",
    "--color-secondary-main": "var(--sg-color-secondary-main)",
    "--color-secondary-dark": "var(--sg-color-secondary-dark)",
    "--color-secondary-contrast": "var(--sg-color-secondary-contrast)",
    "--color-accent-light": "var(--sg-color-accent-light)",
    "--color-accent-main": "var(--sg-color-accent-main)",
    "--color-accent-dark": "var(--sg-color-accent-dark)",
    "--color-accent-contrast": "var(--sg-color-accent-contrast)",
    "--color-neutral-light": "var(--sg-color-neutral-light)",
    "--color-neutral-main": "var(--sg-color-neutral-main)",
    "--color-neutral-dark": "var(--sg-color-neutral-dark)",
    "--color-neutral-contrast": "var(--sg-color-neutral-contrast)",
    "--color-success-light": "var(--sg-color-success-light)",
    "--color-success-main": "var(--sg-color-success-main)",
    "--color-success-dark": "var(--sg-color-success-dark)",
    "--color-success-contrast": "var(--sg-color-success-contrast)",
    "--color-error-light": "var(--sg-color-error-light)",
    "--color-error-main": "var(--sg-color-error-main)",
    "--color-error-dark": "var(--sg-color-error-dark)",
    "--color-error-contrast": "var(--sg-color-error-contrast)",
    "--color-warning-light": "var(--sg-color-warning-light)",
    "--color-warning-main": "var(--sg-color-warning-main)",
    "--color-warning-dark": "var(--sg-color-warning-dark)",
    "--color-warning-contrast": "var(--sg-color-warning-contrast)",
    "--color-info-light": "var(--sg-color-info-light)",
    "--color-info-main": "var(--sg-color-info-main)",
    "--color-info-dark": "var(--sg-color-info-dark)",
    "--color-info-contrast": "var(--sg-color-info-contrast)",
    "--color-background-default": "var(--sg-color-background-default)",
    "--color-background-paper": "var(--sg-color-background-paper)",
    "--color-scrollbar-thumb": "var(--sg-color-scrollbar-thumb)",
    "--color-scrollbar-track": "var(--sg-color-scrollbar-track)",
    "--color-background-code": "var(--sg-color-background-code)",
    "--color-code": "var(--sg-color-code)",
    "--color-divider": "var(--sg-color-divider)"
  },
  "dark": {
    "--sg-color-base-contrast": "#ffffff",
    "--sg-color-base-background": "#090909",
    "--sg-color-primary-light": "#a6acfb",
    "--sg-color-primary-main": "#7267ef",
    "--sg-color-primary-rgb": "114, 103, 239",
    "--sg-color-primary-dark": "#533ac8",
    "--sg-color-primary-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-secondary-light": "#f861ff",
    "--sg-color-secondary-main": "#c700de",
    "--sg-color-secondary-rgb": "0, 211, 187",
    "--sg-color-secondary-dark": "#7d0986",
    "--sg-color-secondary-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-accent-light": "#4dfbdf",
    "--sg-color-accent-main": "#00d3bb",
    "--sg-color-accent-rgb": "114, 103, 239",
    "--sg-color-accent-dark": "#028378",
    "--sg-color-accent-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-neutral-light": "#8387ad",
    "--sg-color-neutral-main": "#414363",
    "--sg-color-neutral-dark": "#383954",
    "--sg-color-neutral-contrast": "#fdf9e8",
    "--sg-color-success-light": "#71ffa4",
    "--sg-color-success-main": "#00a43b",
    "--sg-color-success-dark": "#06752e",
    "--sg-color-success-contrast": "#effcf9",
    "--sg-color-error-light": "#ff5d7d",
    "--sg-color-error-main": "#ea003e",
    "--sg-color-error-dark": "#990237",
    "--sg-color-error-contrast": "#fcf2f8",
    "--sg-color-warning-light": "#fc9704",
    "--sg-color-warning-main": "#df6f00",
    "--sg-color-warning-dark": "#b94b04",
    "--sg-color-warning-contrast": "#fdf9e8",
    "--sg-color-info-light": "#18d8f8",
    "--sg-color-info-main": "#0090b5",
    "--sg-color-info-dark": "#105f7a",
    "--sg-color-info-contrast": "#fcf2f8",
    "--sg-color-background-default": "var(--sg-color-base-background)",
    "--sg-color-background-paper": "#0e0e14",
    "--sg-color-background-code": "#1e1e26",
    "--sg-color-code": "var(--sg-color-primary-main)",
    "--sg-color-divider": "#262629"
  },
  "light": {
    "--sg-color-base-contrast": "var(--color-grey-900)",
    "--sg-color-base-background": "#f8fafc",
    "--sg-color-primary-light": "#8686f2",
    "--sg-color-primary-main": "#554ae8",
    "--sg-color-primary-dark": "#4735cf",
    "--sg-color-primary-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-secondary-light": "#b66eec",
    "--sg-color-secondary-main": "#a44ae8",
    "--sg-color-secondary-dark": "#7233a2",
    "--sg-color-secondary-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-accent-light": "#4dfbdf",
    "--sg-color-accent-main": "#00d3bb",
    "--sg-color-accent-dark": "#028378",
    "--sg-color-accent-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-neutral-light": "#8387ad",
    "--sg-color-neutral-main": "#414363",
    "--sg-color-neutral-dark": "#383954",
    "--sg-color-neutral-contrast": "var(--color-grey-100)",
    "--sg-color-success-light": "#68b36b",
    "--sg-color-success-main": "#43a047",
    "--sg-color-success-dark": "#2e7031",
    "--sg-color-success-contrast": "#ffffff",
    "--sg-color-error-light": "#f6685e",
    "--sg-color-error-main": "#f44336",
    "--sg-color-error-dark": "#aa2e25",
    "--sg-color-error-contrast": "#ffffff",
    "--sg-color-warning-light": "#ffa733",
    "--sg-color-warning-main": "#ff9100",
    "--sg-color-warning-dark": "#b26500",
    "--sg-color-warning-contrast": "#ffffff",
    "--sg-color-info-light": "#81d3fa",
    "--sg-color-info-main": "#03a9f4",
    "--sg-color-info-dark": "#0476bd",
    "--sg-color-info-contrast": "#ffffff",
    "--sg-color-background-default": "var(--sg-color-base-background)",
    "--sg-color-background-paper": "var(--color-grey-200)",
    "--sg-color-scrollbar-thumb": "var(--color-grey-200)",
    "--sg-color-scrollbar-track": "var(--color-grey-100)",
    "--sg-color-background-code": "var(--color-grey-200)",
    "--sg-color-code": "var(--sg-color-primary-dark)",
    "--sg-color-divider": "color-mix(\n    in srgb,\n    var(--sg-color-base-contrast) 20%,\n    transparent\n  )"
  },
  "twilight": {
    "--sg-color-base-contrast": "rgb(189, 200, 240)",
    "--sg-color-base-background": "#1a223f",
    "--sg-color-primary-light": "#8e85f2",
    "--sg-color-primary-main": "#7267ef",
    "--sg-color-primary-dark": "#4f48a7",
    "--sg-color-primary-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-secondary-light": "#c485f2",
    "--sg-color-secondary-main": "#b667ef",
    "--sg-color-secondary-dark": "#7f48a7",
    "--sg-color-secondary-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-accent-light": "#4dfbdf",
    "--sg-color-accent-main": "#00d3bb",
    "--sg-color-accent-dark": "#028378",
    "--sg-color-accent-contrast": "var(--sg-color-base-contrast)",
    "--sg-color-neutral-light": "#8387ad",
    "--sg-color-neutral-main": "#414363",
    "--sg-color-neutral-dark": "#383954",
    "--sg-color-neutral-contrast": "var(--sg-color-grey-100)",
    "--sg-color-success-light": "#68b36b",
    "--sg-color-success-main": "#43a047",
    "--sg-color-success-dark": "#2e7031",
    "--sg-color-success-contrast": "#ffffff",
    "--sg-color-error-light": "#f6685e",
    "--sg-color-error-main": "#f44336",
    "--sg-color-error-dark": "#aa2e25",
    "--sg-color-error-contrast": "#ffffff",
    "--sg-color-warning-light": "#ffa733",
    "--sg-color-warning-main": "#ff9100",
    "--sg-color-warning-dark": "#b26500",
    "--sg-color-warning-contrast": "#ffffff",
    "--sg-color-info-light": "#81d3fa",
    "--sg-color-info-main": "#03a9f4",
    "--sg-color-info-dark": "#0476bd",
    "--sg-color-info-contrast": "#ffffff",
    "--sg-color-background-default": "var(--sg-color-base-background)",
    "--sg-color-background-paper": "rgb(37, 45, 72)",
    "--sg-color-scrollbar-thumb": "color-mix(\n    in srgb,\n    var(--sg-color-background-default),\n    white 15%\n  )",
    "--sg-color-scrollbar-track": "color-mix(\n    in srgb,\n    var(--sg-color-background-default),\n    black 10%\n  )",
    "--sg-color-background-code": "#1e1e26",
    "--sg-color-code": "var(--sg-color-primary-main)",
    "--sg-color-divider": "color-mix(\n    in srgb,\n    var(--sg-color-base-contrast) 20%,\n    transparent\n  )"
  }
} as const;


// --- Generated Types ---

export type ThemeVariablesMap = typeof themeMap;
export type ThemeName = keyof Omit<ThemeVariablesMap, 'base'>;
export type ThemeVariablesByName<N extends ThemeName> = ThemeVariablesMap[N];
export type ThemeBaseVariables = ThemeVariablesMap['base'];

// --- Generated Functions ---

/**
 * Get the theme variables for a given theme name.
 *
 * @param themeName The name of the theme to get the variables for.
 * @returns The theme variables for the given theme name.
 */
export function getThemeVariablesByName(themeName: ThemeName) {
  return themeMap[themeName];
}

/**
 * Get a theme variable for a given theme name and variable name.
 *
 * @param themeName The name of the theme to get the variable for.
 * @param variable The name of the variable to get.
 * @returns The variable value.
 */
export function getThemeVariableByName<N extends ThemeName>(themeName: N, variable: keyof ThemeVariablesByName<N>) {
  return getThemeVariablesByName(themeName)[variable];
}

/**
 * Get the base variables.
 *
 * @returns The base variables.
 */
export function getThemeBaseVariables() {
  return themeMap.base;
}
